import React, {useEffect, useRef, useState} from 'react';
import {postData} from "@/utils/sendData";
import {deserializedData} from "@/utils/deserializedData";
import RegionSuggest from "@/views/Admin/Statistic/Member/RegionSuggest/RegionSuggest";
import {useRouteMatch} from "react-router-dom";
import styles from './EditField.module.scss';
import {EditFieldSchema} from "@/views/Admin/Statistic/Member/EditField/EditField.schema";
import {API} from "@/api/API";
import {EditFieldInterface} from "@/views/Admin/Statistic/Member/EditField/EditField.interface";
import {Button, useToast} from "uikit";
import JSONAPISerializer from "jsonapi-serializer/lib/serializer";

//Базовый компонент для редактирования поля в статистике заказа
const EditField = ({fieldId}: {fieldId: number}) => {
    const [fieldData, setFieldData] = useState<EditFieldInterface>({...EditFieldSchema});

    const {dataset} = document.getElementById('region-field');
    const toast = useToast();
    const {params}: any = useRouteMatch();

    useEffect(() => {
        handleGetFieldValue();
    }, []);

    useEffect(() => {
        handleGetRegions();
    }, []);

    //Получение списка субъектов РФ, при переходе на react перенести в RegionSuggest
    const handleGetRegions = async () => {
        try {
            const res = await postData(null, '/assets/json/regions.json', 'GET');
            setFieldData(prev => ({...prev, regionList: res.data.list}));
        } catch (err) {
            console.log(err);
        }
    }

    //Получение данных поля
    const handleGetFieldValue = async () => {
        try {
            const res = await postData(null, API.getStatisticFieldValue.path(fieldId), API.getStatisticFieldValue.method);
            const data = await deserializedData(res.data);
            setFieldData(prev => ({...prev, fieldValue: {...data}}));
        } catch (err) {
            console.log(err);
        }
    }

    const handleUpdateField = async (e) => {
        let serialize, field, fieldContent;

        field = e.target.closest('.order-member__field');
        fieldContent = field.querySelector('.order-member__field--content')

        serialize = new JSONAPISerializer('order-forms', {
            keyForAttribute: 'underscore_case',
            attributes: ['data', 'event_order_form_id', 'event_order_ticket_id', 'form_id', 'order_id'],
        }).serialize({...fieldData.fieldValue, order_id: params.id});

        try {
            const res = await postData(serialize, `/api/admin/v1/order-forms/${fieldId}`, 'PATCH');
            const d = await deserializedData(res.data);
            const value = fieldData.regionList.find(region => region.id === Number(d.data));
            fieldContent.textContent = value.name;
            // @ts-ignore
            showTopMessage('success', 'small' , 'Поле успешно отредактировано');
            handleButtonClick(e);
        } catch ({response}) {
            response.status === 422 ? setFieldData(prev => (
                {...prev,
                    editInput: {
                    ...prev.editInput, error: response.data.errors[0].detail
                }}
            )) : null;
            toast({
                message: 'Ошибка. Что-то пошло не так',
                type: 'danger',
                duration: 3000,
            });
        }
    }

    const handleHideForm = (e) => {
        setFieldData(prev => ({...prev, value: {...EditFieldSchema.fieldValue}}));
        handleButtonClick(e);
    }

    //Скрытие формы редактирования
    const handleButtonClick = (e) => {
        const field = e.target.closest('.order-member__field');
        if (field) {
            const fieldData = field.querySelector('.order-member__field--main');
            const fieldEditor = field.querySelector('.order-member__field--editor');
            const button = field.querySelector('.order-member__action');

            if (fieldEditor) {
                fieldEditor.style.display = 'none';
                fieldEditor.querySelector('.region-field-suggest').setAttribute('data-edit', 'false');
                fieldData.style.display = 'block'
            }

            if (button) {
                button.style.display = 'block';
                button.disabled = true;
            }
        }
    };

    return (
        <div className={styles.container}>
            {dataset.type === 'region' ? <RegionSuggest data={fieldData} onChange={setFieldData}/> : null}
            <div className={styles.btns}>
                <Button size={'medium'} type={'tertiary'} theme={'ghost'} onClick={(e) => handleHideForm(e)}>отмена</Button>
                <Button size={'medium'} type={'primary'} theme={'default'} onClick={(e) => handleUpdateField(e)}>сохранить</Button>
            </div>
        </div>
    );
};

export default EditField;
